import { formatMoney } from '@betterment/core';
import { useGraphQLQuery } from '@betterment/graphql';
import { Box, Card, Heading, Separator, Spinner } from '@betterment/samba-react';
import { format } from 'date-fns';

import { MinimalFeeWarning } from '../../../../Shared/components-v2/minimal-fee-warning/MinimalFeeWarning';
import { ForecasterProjectionLoadingState } from '../../../shared/components/forecaster-projection-loading-state/ForecasterProjectionLoadingState';
import { ForecasterProjectionChart } from '../../../shared/components/ForecasterProjectionChart';
import { ProjectionHighlight } from '../../../shared/components/ProjectionHighlight';
import { ForecasterProjectionDisclosuresDocument } from '../../../shared/graphql/forecasterProjectionDisclosures.generated';
import { useForecasterAccountProjection } from '../../context/ForecasterAccountProjectionContext';

export const AccountProjectionCard = () => {
  const { account, isLoading } = useForecasterAccountProjection();
  const { data: disclosuresData } = useGraphQLQuery(ForecasterProjectionDisclosuresDocument, {
    throwOnError: true,
  });
  const { disclosures } = disclosuresData || {};

  if (!account || !disclosures) return <ForecasterProjectionLoadingState />;
  if (account.__typename !== 'ManagedAccount') return null;

  const { balanceTimeSeries: timeSeries } = account.projection || {};
  if (!timeSeries) return null;

  const expectedBalance = timeSeries[timeSeries.length - 1];

  return (
    <Card css={{ display: 'grid', gap: 'space.300', padding: 'space.300', position: 'relative' }}>
      {isLoading && (
        <Box
          css={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1,
            backgroundColor: 'primitives.white.100alpha30',
          }}
        >
          <Spinner />
        </Box>
      )}
      <Card.Header css={{ display: 'flex', flexDirection: 'column', gap: 'space.100' }}>
        <Heading variant="title100">Balance projection</Heading>
      </Card.Header>
      <Separator />
      {account.minFeeWarning && <MinimalFeeWarning minFeeWarning={account.minFeeWarning} />}
      <Card.Content>
        <ForecasterProjectionChart timeSeries={timeSeries} disclosures={disclosures}>
          <ForecasterProjectionChart.Header>
            <ProjectionHighlight
              title={`Projected ${format(expectedBalance.date, 'MMM yyyy')}`}
              value={formatMoney(expectedBalance.expected)}
            />
          </ForecasterProjectionChart.Header>
        </ForecasterProjectionChart>
      </Card.Content>
    </Card>
  );
};
